import { css } from "../../../../styled-system/css";

export const styles = {
  card: () =>
    css({
      minHeight: "106px",
      position: "relative",
    }),
  wrapper: () =>
    css({
      marginBottom: "10px",
      lineHeight: "body.cat",
      "& span": {
        lineHeight: "0",
      },
    }),
  shortCardWrapper: () =>
    css({
      display: "block",
      lineHeight: "body.cat",
      "& span": {
        lineHeight: "0",
      },
      mobile: {
        display: "flex",
      },
    }),
  mobileRow: () =>
    css({
      marginBottom: "10px",
      mobile: {
        width: "204px",
        marginBottom: 0,
      },
    }),
  purchasedRow: () =>
    css({
      marginBottom: "10px",
      mobile: {
        display: "none",
      },
    }),
  floatingRisk: () =>
    css({
      position: "absolute",
      right: "0px",
      top: "10px",
    }),

  footer: () =>
    css({
      marginTop: "baseUnit.mobile1",
    }),
};
